import { RotatedTitle } from '../../../../components/rotated-title/rotated-title'
import Pantones from '../../../../components/editable-cell/form-items/pantones'
import { onCellUnlessColorProofDurstRollout } from '../../helpers/color-proof-branch'
import type { CalculationColumn } from '../../types/column-types'

export const pantonesColumn: CalculationColumn = {
    dataIndex: 'pantones',
    title: <RotatedTitle>Пантоны</RotatedTitle>,
    width: 30,
    editable: true,
    FormItem: <Pantones />,
    onCell: onCellUnlessColorProofDurstRollout,
}
